import "./About.css";
import AboutBox from "./AboutBox";
import Me2 from "../../assets/avatar-2.jpg";

const About = () => {
  return (
    <section className="about container section" id="about">
      <h2 className="section__title">
        About Me
      </h2>

      <div className="about__container grid">
        <img
          src={Me2}
          alt="My Avatar 2"
          className="about__img"
        />

        <div className="about__data grid">
          <div className="about__info">
            <p className="about__description">
            I am William, a software engineering intern building complete applications from front-end interfaces to back-end architecture using React, TypeScript, Node.js, and Python. As an Honors Scholar at Georgia State University, I've spent my internships and projects turning real problems — payment support tools, campus apps, nonprofit data systems — into shipped software.
            </p>

            <a href="#portfolio" className="btn">
              View My Projects
            </a>
          </div>

          <div className="about__skills grid">
            <div className="skill__data">
              <div className="skill__title">
                <h3 className="skill__name">Front End</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage frontend"></span>
              </div>
            </div>

            <div className="skill__data">
              <div className="skill__title">
                <h3 className="skill__name">Back End</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage backend"></span>
              </div>
            </div>

            <div className="skill__data">
              <div className="skill__title">
                <h3 className="skill__name">Databases</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage databases"></span>
              </div>
            </div>

            <div className="skill__data">
              <div className="skill__title">
                <h3 className="skill__name">Version Control</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage versioncontrol"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skill__title">
                <h3 className="skill__name">Web Hosting</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage webhosting"></span>
              </div>
            </div>

            <div className="skill__data">
              <div className="skill__title">
                <h3 className="skill__name">DevOps</h3>
                <span className="skill__number"></span>
              </div>

              <div className="skill__bar">
                <span className="skill__percentage devops"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AboutBox />
    </section>
  )
}

export default About